import { useLocation, useNavigate } from 'react-router'
import Tabs from 'src/Components/Tabs'

interface IWebAdminNav {
  children: React.ReactNode
}

const WebAdminNav = ({ children }: IWebAdminNav) => {
  const navigate = useNavigate()
  const location = useLocation()
  const tabsList = [
    {
      title: 'Base information',
      link: '/site-admin'
    },
    {
      title: 'Case studies',
      link: '/site-admin/case-studies'
    },
    {
      title: 'Blog',
      link: '/site-admin/blog'
    }
  ]
  const changeTab = (index: number) => {
    navigate(tabsList[index].link)
  }

  return (
    <>
      <h1>WebAdmin</h1>
      <section className="block">
        <Tabs
          list={tabsList.map((item) => item.title)}
          onChange={(i) => changeTab(i)}
          name="webAdminTabs"
          baseItem={tabsList.findIndex((item) => item.link === location.pathname)}
        />
        {children}
      </section>
    </>
  )
}

export default WebAdminNav
